import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { RoleDetailsForm, RoleModel } from '../../../../models/role-permissions.model';

export interface RolePermState extends EntityState<RoleModel> {

    selectedEntity: RoleModel;

    updateRoleListing: boolean;
    updateUserRoleListing: boolean;
    updateTeamRoleListing: boolean;
    updateAllPermSetListing: boolean;
    updateClientSideListing: boolean;

    detailsForm: RoleDetailsForm;

    selectedGuid: string;
    errorLog: {timeStamp: Date, log: string}[];
    totalRecords: number,
    requiresUpdate: boolean;
}

export const rolePermAdapters: EntityAdapter<RoleModel> = createEntityAdapter<RoleModel>({
    selectId: a => a.app_mst_role.guid.toString()
});

export const initialState: RolePermState = rolePermAdapters.getInitialState({

    selectedEntity: null,

    updateRoleListing: false,
    updateUserRoleListing: false,
    updateTeamRoleListing: false,
    updateAllPermSetListing: false,
    updateClientSideListing: false,

    detailsForm: null,

    selectedGuid: null,
    errorLog: [],
    totalRecords: 0,
    requiresUpdate: false
})
